import SensorList from './SensorList';

export default SensorList;
